import { render, staticRenderFns } from "./RemindSetting.vue?vue&type=template&id=2c785da6&"
import script from "./RemindSetting.vue?vue&type=script&lang=js&"
export * from "./RemindSetting.vue?vue&type=script&lang=js&"
import style0 from "./RemindSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports